.ff{border:1px solid #ddd;}